import styled from 'styled-components';
import { heading3, textSmallSemiBold } from '@hud/web-components/DesignSystem/Typography';
import { HudIcon } from '../Icons/HudIcons';
import { ellipsisMixin } from '../theme/utils';
import { Button } from '../Button/Button';
import { Modal } from '../Modal/Modal';

export const CellIcon = styled(HudIcon)`
  vertical-align: middle;
  position: relative;
  top: -1px;
  margin-right: var(--space-50);
  color: var(--text-standard-secondary);
`;

export const StyledMoreItemsContainer = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-right: var(--space-100);
`;

export const StyledMoreItemButton = styled(Button).attrs({
  variant: 'outlined',
})`
  display: flex;
  height: 24px;
  padding: var(--space-50);
  align-items: center;
  gap: var(--space-25);
`;

export const EntitiesList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-200);

  & a {
    ${textSmallSemiBold};
    ${ellipsisMixin};
    color: var(--text-standard-primary);
    text-decoration: underline;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: var(--space-250);
  padding-bottom: var(--space-250);

  .forensicsTitle {
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;
      align-items: center;
      gap: var(--space-100);

      ${heading3};
      color: var(--text-standard-primary);
    }
  }

  .timestamp {
    ${textSmallSemiBold};
    color: var(--text-standard-secondary);
    margin-top: var(--space-25);
  }

  .traceIds {
    display: flex;
    flex-direction: column;
    gap: var(--space-50);
    color: var(--text-standard-secondary);
    ${textSmallSemiBold};

    button {
      padding: var(--space-25);
      margin-left: var(--space-100);
    }
  }
`;

export const StyledModal = styled(Modal)`
  height: 80vh;
  min-width: 80vw;
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${heading3};

  .jsonTitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--space-150);
  }

  .timestamp {
    ${textSmallSemiBold};
    color: var(--text-standard-secondary);
    margin-top: var(--space-25);
  }

  button {
    padding: var(--space-75) var(--space-100);
  }
`;

export const JsonContent = styled.div`
  display: flex;
  overflow: auto;
  max-height: 70vh;
  max-width: 78vw;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
`;
